"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_REVIEW_STATUS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.SET_REVIEW_STATUS = (0, gql_1.gql)(`
  mutation ProductAttributeReview(
    $productAttributeReview: ProductAttributeReviewInput!,
    $attribute: String!,
    $attributeType: ProductAttributeType!
  ) {
    productAttributeReview(productAttributeReview: $productAttributeReview) {
      success
      error
      productAttributeReview {
        attribute
        attributeType
        status
        product {
          id
          lastReviewedBy(attribute: $attribute, attributeType: $attributeType) {
            id
            name
          }
        }
      }
    }
  }
`);
